import React from 'react';
import { Typography, theme } from 'antd';

const { Text } = Typography;

export interface IBookingReferenceTagProps {
  /** e.g. "R-PPTAR". Renders nothing at all when absent -- an empty label is worse than no label. */
  reference?: string;

  /** Adds antd's copy affordance. Worth it where somebody is about to quote this on the phone or paste it into an email; noise on a list where every row would sprout an icon. */
  copyable?: boolean;

  style?: React.CSSProperties;
}

/**
 * What a booking is called, wherever it is shown.
 *
 * One component so the reference reads the same on a card, in a thread, on
 * the tracking page and on an albaran -- it is meant to be recognised at a
 * glance across four screens, which it can't be if each one styles it
 * differently.
 *
 * Tabular figures and a little letter-spacing on purpose: this is a code to
 * be read out character by character, not a word.
 */
const BookingReferenceTag: React.FC<IBookingReferenceTagProps> = ({ reference, copyable, style }) => {
  const { token } = theme.useToken();

  if (!reference) return null;

  return (
    <Text
      type="secondary"
      copyable={copyable ? { text: reference } : false}
      style={{
        fontSize: 12,
        letterSpacing: 0.8,
        fontVariantNumeric: 'tabular-nums',
        color: token.colorTextTertiary,
        ...style,
      }}
    >
      {reference}
    </Text>
  );
};

export default BookingReferenceTag;
